import { IconButton } from "@material-tailwind/react";
import { useRef } from "react";
import toast from "react-hot-toast";
import { ReactComponent as UploadCSV } from "../../Assets/Svg/UploadCSV.svg";

const CSVUploader = ({
  setDisplayContacts,
  setContacts,
  setOpenMemberSelect,
  selectedContacts,
}) => {
  const inputRef = useRef(null);
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const email = localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user"))?.email
          : "";
        const selectedMembers = email
          ? [...selectedContacts, { label: email, value: email }]
          : selectedContacts;
        const text = e.target.result;
        const parsedData = parseCSV(text);
        const sortedUsers = parsedData?.filter(
          (user) => user.email && user.first_name
        );
        const filterUsers = sortedUsers
          ?.filter((user) =>
            selectedMembers?.every((contact) => contact.value !== user.email)
          )
          .map((user, i) => ({
            label: `${user.first_name} ${user.last_name ? user.last_name : ""}`,
            value: user.email,
            id: user.id + i + Date.now(),
          }));
        setContacts(filterUsers);
        setDisplayContacts(filterUsers);
        setOpenMemberSelect(true);
        event.target.value = "";
      };
      reader.readAsText(file);
    } else {
      toast.error("Please select a valid CSV file.");
    }
  };

  const parseCSV = (text) => {
    const lines = text.split("\n").filter((line) => line.trim()); // Split by lines
    const headers = lines[0]
      .split(",")
      .map((header) => header.trim().replace(/^"|"$/g, "")); // Clean up extra quotes from headers

    return lines.slice(1).map((line) => {
      const values = line
        .split(",")
        .map((value) => value.trim().replace(/^"|"$/g, "")); // Remove quotes from values
      const user = {};
      headers.forEach((header, index) => {
        user[header] = values[index]; // Map headers to values without quotes
      });
      return user;
    });
  };

  return (
    <div>
      <IconButton
        variant="text"
        id={"Upload-CSV"}
        onClick={() => inputRef.current.click()}
      >
        <UploadCSV className="h-6 w-6 text-secondary" />
      </IconButton>

      <input
        ref={inputRef}
        type="file"
        className="hidden"
        accept=".csv"
        onChange={handleFileUpload}
      />
    </div>
  );
};

export default CSVUploader;
